import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maskToDefinitionsPipe',
})
export class MaskToDefinitionsPipe implements PipeTransform {
  transform(values: Record<string, RegExp>): Record<string, { pattern: RegExp }> {
    if (!values) return null;
    const obj: Record<string, { pattern: RegExp }> = {};
    for (const [prop, value] of Object.entries(values)) {
      obj[`${prop}`] = { pattern: new RegExp(value) };
    }
    return obj;
  }
}
